import lodashCloneDeep from 'lodash/fp/cloneDeep';
import { USER_ROLE_ANONYMOUS } from 'common/userRoles';
import { DEFAULT_MARKET_ID, DEFAULT_MARKET_MAP_SETTINGS_AREA } from 'common/marketConstants';
import propertyOptionItems from 'client/helpers/propertyOptionItems';

export default {
  roles: [USER_ROLE_ANONYMOUS],
  settings: {},
  searchFilters: {
    marketId: DEFAULT_MARKET_ID,
    area: lodashCloneDeep(DEFAULT_MARKET_MAP_SETTINGS_AREA),
    pets: [],
    bedrooms: [0, 1, 2, 3, 4],
    moveInDate: null,
    propertyTypes: propertyOptionItems.map(({ value }) => value),
    minRentPrice: 850,
    maxRentPrice: 20000,
    availableHomesNearMoveInDate: false,
    section8: false,
  },
  sessionCount: 1,
};
